<template>
    <!-- Page header -->
    <div class="bg-white py-2 w-full px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:px-8">
        <div class="flex items-center space-x-5">
            <div class="flex-shrink-0">
                <div class="relative">
                    <img class="h-16" :src="'data:image/png;base64, '+partnerSettings.logo" alt="">
                </div>
            </div>
            <div>
                <h1 class="text-2xl font-bold text-gray-900">{{ partnerSettings.name }}</h1>
                <p class="text-sm font-medium text-gray-500">Založeno <span>{{ (new Date(partnerSettings.created_at)).toLocaleDateString() }}</span> správcem <span class="">{{ user.name }}</span></p>
            </div>
        </div>
        <div class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
            <button @click="openSettings" type="button" class="inline-flex items-center justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">Změnit nastavení</button>
        </div>
    </div>

    <dialog-modal :show="updatingSettings">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <!-- Heroicon name: exclamation -->
                <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            </div>
        </template>
        <template #title>Nastavení partnerského účtu</template>
        <template #content>
            <!-- Name -->
            <div class="mt-2 col-span-6 sm:col-span-4">
                <jet-label required for="name">Název společnosti</jet-label>
                <jet-input required id="name" type="text" class="mt-1 block w-full" v-model="form.name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
            </div>
            <!-- Logo -->
            <div class="mt-2 col-span-6 sm:col-span-4">
                <jet-label required for="logo">Logo</jet-label>
                <jet-input required id="logo" type="file" class="mt-1 block w-full" @input="form.logo = $event.target.files[0]" />
                <jet-input-error :message="form.errors.logo" class="mt-2" />
            </div>

        </template>
        <template #footer>
            <jet-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="saveSettings" class="ml-2">
                Uložit
            </jet-button>
            <secondary-button :class="{ 'opacity-25': settingsSubmitProcessing }" :disabled="settingsSubmitProcessing" @click.native="closeSettings">
                Zrušit
            </secondary-button>
        </template>
    </dialog-modal>
</template>

<script>
import DialogModal from "../../Jetstream/DialogModal";
import SecondaryButton from "../../Jetstream/SecondaryButton";
import Button from "../../Jetstream/Button";
import Label from "../../Jetstream/Label";
import InputError from "../../Jetstream/InputError";
import JetInput from "../../Jetstream/Input";
export default {
    name: "PartnerHeader",
    components: {SecondaryButton, DialogModal, 'jet-button': Button, JetInput, 'jet-input-error': InputError, 'jet-label': Label},
    data(){
        return {
            user: this.$page.props.user,
            updatingSettings: false,
            settingsSubmitProcessing: false,
            partnerSettings: this.$page.props.partnerSettings,

            form: this.$inertia.form({
                'name': this.$page.props.partnerSettings.name,
                'logo': null,
                'webhook_url': this.$page.props.partnerSettings.webhook_url
            }),
        }
    },
    methods: {
        openSettings() {
            this.updatingSettings = true;
        },
        closeSettings(){
            this.updatingSettings = false;
            this.form.reset();
        },
        saveSettings(){
            this.form.post(route('partner.settings'), { forceFormData: true, preserveState: false, });
        }
    },

}
</script>

<style scoped>

</style>
